import React from "react";
import { useMessageSource } from "react-message-source";
import RadioButtonField from "../formik/radiobutton";
import { LanguageBackendType } from "./types";

export default function Language({
  dataPath = "",
  languages = [
    LanguageBackendType.GERMAN,
    LanguageBackendType.FRENCH,
    LanguageBackendType.ITALIAN,
    LanguageBackendType.ENGLISH,
  ],
  onChange,
}: {
  dataPath?: string;
  languages?: string[];
  onChange?: (event: React.SyntheticEvent, value: LanguageBackendType) => void;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  const languageValues = [
    {
      id: LanguageBackendType.GERMAN,
      value: LanguageBackendType.GERMAN,
      label: getMessage("Language.DE"),
    },
    {
      id: LanguageBackendType.FRENCH,
      value: LanguageBackendType.FRENCH,
      label: getMessage("Language.FR"),
    },
    {
      id: LanguageBackendType.ITALIAN,
      value: LanguageBackendType.ITALIAN,
      label: getMessage("Language.IT"),
    },
    {
      id: LanguageBackendType.ENGLISH,
      value: LanguageBackendType.ENGLISH,
      label: getMessage("Language.EN"),
    },
  ].filter((entry) => languages.includes(entry.id));

  return (
    <RadioButtonField
      title={getMessage("Correspondence.language")}
      id={`${dataPath}correspondenceLanguage`}
      name={`${dataPath}correspondenceLanguage`}
      values={languageValues}
      onChangeCallback={onChange}
    />
  );
}
